// extracted by mini-css-extract-plugin
export default {"componentContainer":"componentHeader_componentContainer__I2SkP","componentTitle":"componentHeader_componentTitle__tRAeS"};